import { styled, TextField as MuiTextField } from "@mui/material";

const TextField = styled(MuiTextField)(({theme}) => ({
    '& .MuiInputBase-root': {
        // borderRadius: 0
    },
}));

export default TextField;